import React, { FC, HTMLAttributes, DetailedHTMLProps } from 'react';

export {
  Add,
  AddSmall,
  Adjust,
  Bookmark,
  BookmarkFilled,
  Check,
  ChevronDownSmall,
  ChevronLeft,
  ChevronRight,
  ChevronRightSmall,
  ChevronUpSmall,
  ContentFilter,
  Crop,
  CropRotate,
  CropRotateSmall,
  CutOut,
  Download,
  Edit,
  EmptyTrash,
  HelpSmall,
  LayoutGallery,
  LayoutGallerySmall,
  LayoutList,
  LayoutListSmall,
  LinkSmall,
  More,
  MoreSmall,
  NewFolder,
  NewFolderSmall,
  PauseFilled,
  PlayFilled,
  Premium,
  Refresh,
  RenameSmall,
  Replace,
  Revert,
  Search,
  SortAscending,
  SortAscendingSmall,
  SortAZ,
  SortAZSmall,
  SortDescending,
  SortDescendingSmall,
  SortZA,
  SortZASmall,
  Star,
  StarFilled,
  StatusAlert,
  StatusAlertFilled,
  StatusAlertFilledSmall,
  StatusCompleteFilled,
  Upload,
  X,
  Users,
  SiteAdd,
  SparklesSmall,
  ExternalLinkSmall,
  SiteSearch,
} from '@wix/wix-ui-icons-common';

export { default as Preview } from './assets/Preview.svg';
export { default as PricingIcon } from './assets/PricingIcon.svg';
export { default as VideoMaker } from './assets/VideoMaker.svg';

import { default as adobeExpressLogoUrl } from './assets/AdobeExpressLogo.svg?url';

export const AdobeExpressLogo: FC<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = (props) => (
  <div {...props}>
    <img width={18} height={18} src={adobeExpressLogoUrl} alt="" />
  </div>
);
